import React from "react";
import PolicyTermsPage from "../Components/policyterms";

const termsData = [
  {
    title: "1. Acceptance of Terms",
    content: "By using the Best Bosses website, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website."
  },
  {
    title: "2. User Registration",
    content: "To access certain features of Best Bosses, you may need to create an account. You are responsible for maintaining the confidentiality of your account credentials."
  },
  {
    title: "3. User Content",
    content: [
      "a. Users may submit content, such as reviews and comments. You are solely responsible for the content you submit.",
      "b. We have the right to remove or modify user content that violates our policies or applicable laws."
    ]
  },
  {
    title: "4. Intellectual Property",
    content: "All content on Best Bosses, including text, graphics, logos, and trademarks, is owned by us and protected by copyright and other intellectual property laws."
  },
  {
    title: "5. Prohibited Activities",
    content: [
      "a. Use the website for unlawful purposes.",
      "b. Violate the privacy of others.",
      "c. Engage in unauthorized access or use of our systems."
    ]
  },
  {
    title: "6. Termination",
    content: "We reserve the right to terminate or suspend your account at our discretion, without notice."
  },
  {
    title: "7. Disclaimers",
    content: [
      "a. We do not endorse or guarantee the accuracy of user-generated content.",
      "b. We do not guarantee the availability or quality of our website at all times."
    ]
  },
  {
    title: "8. Limitation of Liability",
    content: "We are not liable for any direct or indirect damages arising from your use of our website."
  },
  {
    title: "9. Governing Law",
    content: "These Terms of Service are governed by United States and California law."
  },
  {
    title: "10. Contact Us",
    content: "If you have any questions about these terms or our website, please contact us at info@bestbosses.org."
  }
];

const TermsOfService = () => {
  return (
    <div style={{
      backgroundColor: "#F5F6FE",
      width: "100%",
      fontFamily:"Urbanist",
      padding: "48px 0",
    }}>
      <h1 style={{
        textAlign: "center",
        fontSize: "4rem",
        fontWeight: "bold",
        fontFamily:"Urbanist",
        color: "#181C23",
        marginBottom: "0.35rem",
        lineHeight: "1.2"
      }}>
        Terms of Service
      </h1>
      <p style={{ 
        textAlign: "center", 
        marginBottom: "2.5rem", 
        fontSize: "1rem", 
        color: "#181C23", 
        fontWeight: "500" 
      }}>
        Last Updated: December 29, 2023
      </p>
      <div style={{
        width: "90%",
        maxWidth: "1200px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: "1.25rem",
      }}>
        {termsData.map((section, index) => (
          <PolicyTermsPage 
            key={index}
            title={section.title}
            content={section.content}
            isLast={index === termsData.length - 1}
          />
        ))}
      </div>
    </div>
  );
};

export default TermsOfService;